import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/brands.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { ColorRing } from "react-loader-spinner";
import { server } from "../server";

const Brands = () => {
  const [brands, setBrand] = useState([]);
  const [loading, setLoading] = useState(true);

  // SEO metadata
  const pageTitle = "Car Brands Available in Kenya | Classic Motors KE";
  const pageDescription =
    "Explore our wide range of premium car brands available in Mombasa, Kenya. Classic Motors KE offers the best selection of new and used vehicles from top manufacturers.";
  const canonicalUrl = "https://www.classicmotorske.com/brands";
  const keywords =
    "car brands Kenya, vehicle manufacturers Mombasa, best car brands, auto brands in Kenya, Classic Motors KE inventory";

  const getAllBrand = async () => {
    try {
      const { data } = await axios.get(`${server}/api/brand/getAll-brand`);
      if (data.success) {
        setBrand(data.brands);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(true);
    }
  };

  const generateBrandSchema = () => {
    const brandItems = brands.map((brand) => ({
      "@type": "Brand",
      name: brand.name,
      logo: brand.image[0]?.url,
      url: `${canonicalUrl}/${brand.slug}`,
    }));

    return {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: pageTitle,
      description: pageDescription,
      url: canonicalUrl,
      mainEntity: {
        "@type": "AutoDealer",
        name: "Classic Motors KE",
        brand: brandItems,
      },
    };
  };

  useEffect(() => {
    getAllBrand();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <script type="application/ld+json">
          {JSON.stringify(generateBrandSchema())}
        </script>
      </Helmet>

      <section
        id="brands"
        className="brand_wrapper"
        style={{ marginTop: "60px" }}
        itemScope
        itemType="https://schema.org/AutoDealer"
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h1 className="brand_title" itemProp="name">
                Premium Car Brands Available in Kenya
              </h1>
              <p className="brand_subtitle">
                Explore our exclusive selection of international and local car
                brands at Classic Motors KE, Mombasa's trusted vehicle dealer
              </p>
            </div>
          </div>
          {loading ? (
            <div className="h-100 d-flex align-items-center justify-content-center">
              <ColorRing
                visible={true}
                colors={[
                  "#000435",
                  "rgb(14 165 233)",
                  "rgb(243 244 246)",
                  "#000435",
                  "rgb(14 165 233)",
                ]}
              />
            </div>
          ) : (
            <div className="row justify-content-center">
              {brands?.map((brand, index) => (
                <div
                  key={brand._id}
                  className="col-lg-3 col-md-4 col-sm-6 mb-4 showcase_card"
                  itemProp="brand"
                  itemScope
                  itemType="https://schema.org/Brand"
                >
                  <Link to={`/brand/${brand.slug}`} itemProp="url">
                    <img
                      src={brand.image[0].url}
                      className="mb-4 img-fluid"
                      alt={`${brand.name} logo - Available at Classic Motors KE`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "190px",
                        objectFit: "contain",
                      }}
                      title={`${brand.name} vehicles in Kenya`}
                      itemProp="logo"
                    />
                    <meta itemProp="name" content={brand.name} />
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Brands;
